import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/admin/Home.vue'

Vue.use(VueRouter)

import store from '@/store';
import { USER_GETTERS } from '@/store/user/getters';
import { resolveNavigation } from '@/router/authGuard'

import adminRoutes from '@/router/modules/admin'
import coachRoutes from '@/router/modules/coach';
import participantRoutes from '@/router/modules/participant'
import publicRoutes from '@/router/modules/public'

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  ...adminRoutes,
  ...coachRoutes,
  ...participantRoutes,
  ...publicRoutes,
  {
    path: '/login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/confirm-account',
    redirect: '/login'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  const decision = resolveNavigation({
    authLoading: store.getters[USER_GETTERS.AUTH_LOADING],
    isAuthenticated: store.getters[USER_GETTERS.IS_AUTHENTICATED],
    userType: store.getters[USER_GETTERS.USER_TYPE],
    path: to.path,
  })

  if (decision.type === 'wait') {
    return setTimeout(() => {
      next(to.fullPath)
    }, 200)
  }

  if (decision.type === 'redirect') {
    return next(decision.to)
  }

  return next()
});

export default router
